import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { IPeriod, IPeriodWithHolidays } from '@interfaces/IPeriod';
import { Observable } from 'rxjs';
import { environment } from '../../../../environments/environment';

@Injectable({
  providedIn: 'root',
})
export class PeriodsViewService {
  constructor(private _http: HttpClient) {}

  get(id: number): Observable<IPeriod> {
    const url = `${environment.baseUrl}api/v1/periods/${id}/`;
    return this._http.get<IPeriod>(url);
  }

  getGroupPeriods(groupId: number): Observable<IPeriodWithHolidays[]> {
    const url = `${environment.baseUrl}api/v1/groups/${groupId}/periods/`;
    return this._http.get<IPeriodWithHolidays[]>(url);
  }
}
